// @flow strict

import * as React from 'react';

import ManagedTextInput, { type Props as ManagedTextInputProps } from './ManagedTextInput';

import styles from './UnderlinedTextInput.css';

// type Props = {|
/**
 * The font size of the text input (ex. '18px', '1em', etc.). This is required to ensure the underline is the same
 * font-size as the input. This is an optional property on ManagedTextInput but is required for this component since
 * we need to ensure the font size is the same on the text input and the underline.
 */
/*  fontSize: string,
|} & ManagedTextInputProps; */

/**
 * A managed text input field that has a gray underline that progressively turns to green as you type.
 *
 * Note that this component uses the same props as the ManagedTextInput component but due to a bug in StoryBook
 * they will not show on this StoryDoc.
 */
const UnderlinedTextInput = (props: ManagedTextInputProps) => (
  <div className={styles.input_container}>
    <ManagedTextInput {...props} />
    <span className={styles.underline} style={{ fontSize: props.fontSize }}>
      {props.value}
    </span>
  </div>
);

UnderlinedTextInput.defaultProps = {
  fontSize: '12px',
};

export default UnderlinedTextInput;
